// extracted by mini-css-extract-plugin
export default {"title":"DeviceRow_title__I1rfg","cardText":"DeviceRow_cardText__rb1rA","text":"DeviceRow_text__l4LM4","icon":"DeviceRow_icon__E3MmB"};